import React from "react";
import LoadingComponent from "components/atoms/LoadingComponent/LoadingComponent";

interface PageWrapperComponentProps {
  loading?: boolean;
  children: React.ReactElement
}
const PageWrapperComponent = ({ loading = false, children }: PageWrapperComponentProps) => {

  return (
    <div className="PageWrapperComponent">
      {loading ? <LoadingComponent /> : children}
    </div>
  )

}

export default PageWrapperComponent;